import React from 'react';
import { SvgIcon } from '@mui/material';

function BulkSendIcon({ ...props }) {
  return (
    <SvgIcon {...props} viewBox="0 0 130 90">
      <path
        d="M89.8501 28.7901L62.5201 1.42005C60.8401 -0.239951 58.1201 -0.239951 56.4501 1.42005C54.7701 3.14005 54.7701 5.83005 56.4501 7.49005L75.8301 26.9001C71.9601 26.6301 67.6501 26.3201 63.0701 26.1601C53.3201 25.8201 42.2201 26.1 32.1201 28.85C21.9501 31.71 12.4601 37.1501 6.55006 47.2901C1.13006 56.6301 -0.939937 69.29 1.37006 86.15C1.70006 88.54 4.01007 90.18 6.38007 89.76C8.68007 89.36 10.1801 87.1901 9.87006 84.8801C7.74006 69.2801 9.83007 58.7601 13.9701 51.6501C18.4201 43.9801 25.6601 39.57 34.4101 37.17C43.2301 34.71 53.2801 34.42 62.7501 34.77C67.4701 34.94 71.9601 35.29 76.0401 35.57C76.3601 35.59 76.6401 35.61 76.9501 35.63L56.4401 56.1201C54.7601 57.7801 54.7601 60.5301 56.4401 62.1901C58.1201 63.8501 60.8401 63.8501 62.5101 62.1901L89.8401 34.88C91.5201 33.16 91.5201 30.47 89.8401 28.81L89.8501 28.7901Z"
        fill="currentColor"
      />
      <path
        d="M128.31 38.9901C129.99 37.3301 129.99 34.5801 128.31 32.9201L100.98 5.61007C99.2999 3.89007 96.5799 3.89007 94.9099 5.61007C93.2399 7.27007 93.2399 10.0201 94.9099 11.6801L119.2 35.9601L94.9099 60.2401C93.2299 61.9601 93.2299 64.6501 94.9099 66.3101C96.5899 68.0301 99.3099 68.0301 100.98 66.3101L128.3 39.0001L128.31 38.9901Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export default BulkSendIcon;
